import styled from '@emotion/styled'
import cx from 'classnames'

import { builderLightText } from '@/blocks/utils'
import { Container, type BackgroundColor, type Space } from '@/components/Container'
import { BodyM, type TypographyColorModifier } from '@/components/Typography'
import type { TitleProps } from '@/models'

interface DisclaimerPremiumBlockProps {
  id?: string
  subtitle?: TitleProps
  background: BackgroundColor
  backgroundColor?: string
  withBorder?: boolean
  space: Space
  position: 'left' | 'center' | 'right'
  colorModifier?: TypographyColorModifier
}

const DisclaimerPremiumBlockStyles = styled(Container)(() => ({
  margin: '0 auto',

  '& .content': {
    padding: '2rem 0',
  },
  '& .ecs-disclaimer-premium-subt': {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '0.85rem',
    lineHeight: '1rem',
  },
}))

const DisclaimerPremiumBlock = ({
  id,
  subtitle,
  background,
  backgroundColor,
  space = 'm',
  position = 'center',
  colorModifier,
}: DisclaimerPremiumBlockProps) => {
  const lightText = builderLightText(colorModifier)

  return (
    <DisclaimerPremiumBlockStyles
      id={id}
      className={cx({ [`et-ta-${position}`]: position })}
      backgroundColor={background}
      backgroundColorHex={backgroundColor}
      spaceOut={space}
    >
      <div className="content">
        {subtitle && subtitle.text && (
          <BodyM
            light={lightText}
            dark="high"
            className="ecs-disclaimer-premium-subt"
            tag={subtitle.tag}
          >
            {subtitle.text}
          </BodyM>
        )}
      </div>
    </DisclaimerPremiumBlockStyles>
  )
}

export default DisclaimerPremiumBlock
